import RequestService from '@tcc-online/request-service';
import { TRANSLATIONS_ROOT_KEY } from '../../constants/translation.constants';
import { IAuthTokens, IAuthUser } from '../../types';
import DemographicActions from '../../common/actions/DemographicActions';
import { NotificationActions } from '../../common/actions/NotificationActions';
import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import { StorageService } from '../../services';
import AuthActions from '../actions/AuthActions';

const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

const AuthService = {
    requestResetPassword,
    resetPassword,
    login,
    setCustomer,
};

async function requestResetPassword(payload: { email: string }) {
    const { email } = payload;
    return await RequestService.post(
        '/request-reset-password',
        {
            email,
        },
        { ignoreAuth: true },
    );
}

async function resetPassword(payload: {
    controlPassword: string;
    password: string;
}) {
    const { controlPassword, password } = payload;

    return await RequestService.post(
        '/reset-password',
        {
            controlPassword,
            password,
        },
        { ignoreAuth: true },
    );
}

const LOGIN_ERROR_MSG = TRANSLATIONS_ROOT_KEY + '.login.error';
async function login(user: IAuthUser, api: GetThunkAPI<any>) {
    try {
        return await baseLogin(user, api);
    } catch (ex) {
        const { message, response } = ex;
        let error = response?.data?.message || message;
        if (response?.status === 401) {
            error = LOGIN_ERROR_MSG;
            throw new Error(error);
        } else {
            api.dispatch(NotificationActions.error(error));
        }

        throw ex;
    }
}

async function baseLogin(payload: any, api: GetThunkAPI<any>) {
    const response = await RequestService.post('auth/login', payload, {
        ignoreAuth: true,
    });
    const tokens: IAuthTokens[] = response?.data;

    if (!tokens || tokens?.length === 0) {
        throw new Error(LOGIN_ERROR_MSG);
    }

    if (tokens?.length === 1) {
        api.dispatch(AuthActions.selectCustomer(tokens[0]));
    }

    api.dispatch(DemographicActions.toggleDemographics(true));

    return response;
}

function setCustomer(tokens: IAuthTokens) {
    const { accessToken, refreshToken } = tokens;
    StorageService.setLocal(ACCESS_TOKEN_KEY, accessToken);
    StorageService.setLocal(REFRESH_TOKEN_KEY, refreshToken);
}

export default AuthService;
